import script from "./AdminEshops.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminEshops.vue?vue&type=script&setup=true&lang=js"

import "./AdminEshops.vue?vue&type=style&index=0&id=50ba8bc1&scoped=true&lang=css"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ba8bc1"]])

export default __exports__